// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66882222","239":"a6e77140","455":"1de0880d"}[chunkId] + ".chunk.js";
};